// Mirrors the desktop "Analyze FIR" page's language options exactly
// (src/components/UploadDocument.js). Scoped separately from data/languages.js
// (used for the user's native-language preference elsewhere) since the two
// lists serve different purposes and happen to differ (this one includes Odia).
export const FIR_LANGUAGES = [
  'English',
  'Hindi',
  'Gujarati',
  'Marathi',
  'Bengali',
  'Odia',
  'Telugu',
  'Tamil',
  'Kannada',
  'Malayalam',
  'Punjabi',
  'Urdu',
];
